import Icon from '@material-ui/core/Icon';
import withWidth from '@material-ui/core/withWidth';
import React, { Component } from 'react';

import { MyTableContext } from '..';
import styles from '../styles';

export interface IMyTableHeaderIndex {
  title?: string;
  callback?: (index: number) => void;
  numeric?: boolean;
  ordering?: boolean | 'asc' | 'desc';
  el?: JSX.Element;
}

interface IProps {
  index?: IMyTableHeaderIndex[];
  width: any;
  ordering?: boolean | 'asc' | 'desc';
  ordered?: number;
  responsive?: boolean;
  classes?: any;
  onChangeOrder?: (item: IMyTableHeaderIndex, index: number) => void;
}

class MyTableHeader extends Component<IProps, {}> {
  onChangeOrder = (item: IMyTableHeaderIndex, index: number) => {
    return () => {
      item.callback && item.callback(index);
      this.props.onChangeOrder && this.props.onChangeOrder(item, index);
    };
  };

  render() {
    const { index, classes, width, responsive, ordering, ordered } = this.props;

    if (!responsive || width === 'md' || width === 'lg' || width === 'xl') {
      return (
        <thead className={classes.tHead}>
          <tr>
            {index &&
              index.map((item, index) => (
                <th
                  key={`index-${index}`}
                  className={classes.th + (item.numeric ? ' numeric' : '') + (item.ordering ? ' ordering' : '')}
                  onClick={this.onChangeOrder(item, index)}
                >
                  {!!item.title && item.title}
                  {!item.title && item.el && item.el}

                  {ordering && ordered === index ? (
                    ordering === 'asc' ? (
                      <Icon style={{ marginLeft: 4, fontSize: 14, position: 'relative', top: 1 }}>arrow_upward</Icon>
                    ) : (
                      <Icon style={{ marginLeft: 4, fontSize: 14, position: 'relative', top: 1 }}>arrow_downward</Icon>
                    )
                  ) : (
                    ''
                  )}
                </th>
              ))}
          </tr>
        </thead>
      );
    }

    return <div></div>;
  }
}

export default withWidth()(
  styles(
    React.forwardRef((props: IProps, ref: any) => (
      <MyTableContext.Consumer>{(context) => <MyTableHeader {...props} {...context} ref={ref} />}</MyTableContext.Consumer>
    ))
  )
);
